// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax } from 'frontend_core/dist/styles/media'

const SortContainer = styled.span`
  position: relative;
  line-height: 0;

  &::before {
    font-family: FontAwesome;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 3px;
    color: ${Colors.stayPink};
    content: '\f0dd';
    z-index: 1;
  }
`
const SortSelect = styled.select`
  position: relative;
  width: 105px;
  padding: 0 8px;
  color: ${Colors.black};
  font-size: 14px;
  line-height: 12px;
  border: none;
  background-color: transparent;
  z-index: 2;
  cursor: pointer;
  appearance: none;
  ${mediaMax.desktop`
    width: 100px;
    padding: 4px;
    font-size: 13px;
  `};
`

export type PropTypes = {
  options: Array<{
    value: string,
    text: string,
  }>,
  onChange: (selectedValue: string) => void,
  selectedValue: string,
}

export default (props: PropTypes) => (
  <SortContainer>
    <SortSelect
      name="sort"
      onChange={e => props.onChange(e.target.value)}
      value={props.selectedValue}
    >
      {props.options.map(option => (
        <option value={option.value} key={option.value}>
          {option.text}
        </option>
      ))}
    </SortSelect>
  </SortContainer>
)



// WEBPACK FOOTER //
// ./src/components/molecules/SearchSort/index.jsx